var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5943 6.47862H2.7292L7.6334 1.28918C7.84398 1.05381 7.82691 0.693168 7.59166 0.48058C7.364 0.275583 7.01682 0.285074 6.80244 0.503357L0.987599 6.65704C0.962936 6.68362 0.949656 6.71778 0.928787 6.74815C0.909815 6.77662 0.887049 6.8032 0.873769 6.83547C0.847209 6.9038 0.832031 6.97593 0.832031 7.04995V7.05375C0.833928 7.12588 0.849106 7.19611 0.875666 7.26444C0.888946 7.29861 0.911713 7.32518 0.932581 7.35365C0.951553 7.38212 0.962936 7.41629 0.987599 7.44286L6.69809 13.4865C6.91437 13.7161 7.27483 13.7275 7.50439 13.5111C7.50439 13.5111 7.50629 13.5111 7.50629 13.5092C7.73584 13.2929 7.74533 12.9303 7.52905 12.7006L2.7292 7.62129H13.5943C13.9092 7.62129 14.1654 7.36504 14.1654 7.04806C14.1654 6.73297 13.9092 6.47672 13.5943 6.47862Z",
    fill: "#660099"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/arrow-back.ceac2e65ec727eef4e7d9c5bbf5ce864.svg";
export { ForwardRef as ReactComponent };